var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 17.3252V25.6502L45 23.4002V20.2502L40.5 17.3252Z",
    fill: "#9D06FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5498L9 20.2498V23.6248L13.5 25.8748V17.5498Z",
    fill: "#9D06FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2008 13.5L27.0008 9L19.8008 13.5H34.2008Z",
    fill: "#9D06FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 15.75H15.75V26.775L23.4 30.6L27 27.9L30.6 30.6L38.25 26.775V15.75Z",
    fill: "#9D06FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.0996L32.625 32.1746L45 42.0746V26.0996Z",
    fill: "#9D06FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.5996L9 44.9996H45L27 30.5996Z",
    fill: "#9D06FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 32.1746L9 26.0996V42.0746L21.375 32.1746Z",
    fill: "#9D06FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/email-box.3b29a10f7db21167e3cdc8c9fc86f179.svg";
export { ForwardRef as ReactComponent };